import { globalTypes } from "reducers/types/global";

export const types = {
    SET_REQUEST_DATA: "addLimitRequest/SET_REQUEST_DATA",
    SET_PREV_PATH: "addLimitRequest/SET_PREV_PATH",
    SUBMIT_REQUEST: "addLimitRequest/SUBMIT_REQUEST",
    SUBMIT_SUCCESS: "addLimitRequest/SUBMIT_SUCCESS",
    SUBMIT_SUCCESS_REDIRECT: "addLimitRequest/SUBMIT_SUCCESS_REDIRECT",
    SUBMIT_FAILURE: "addLimitRequest/SUBMIT_FAILURE",
    CLEAN_DATA: "addLimitRequest/CLEAN_DATA",
    LOAD_ADDLIMIT_TRANSACTION: "transactions/LOAD_ADDLIMIT_TRANSACTION",
    SET_FETCHING: "addLimitRequest/SET_FETCHING",
    LOAD_PRE_LIMITS: "addLimitRequest/LOAD_PRE_LIMITS",
    SET_PRE_LIMITS: "addLimitRequest/SET_PRE_LIMITS",
    SET_LOADING_LIMITS: "addLimitRequest/SET_LOADING_LIMITS",
    LIMITS_FAILURE: "addLimitRequest/LIMITS_FAILURE",
};

export const INITIAL_STATE = {
    fetching: false,
    requestData: null,
    submitSuccess: false,
    error: null,
    prevPath: null,
    loadingLimits: false,
    limitsByReason: null,
    environmentLimit: null,
    limitsError: null,
    summary: {
        reason: null,
        temporaryLimit: "",
        duration: "",
        currency: "",
    },
};

export default (state = INITIAL_STATE, action = {}) => {
    const { requestData, error, summary, fetching } = action;

    switch (action.type) {
        case types.SET_REQUEST_DATA:
            return {
                ...state,
                requestData,
            };
        case types.SET_PREV_PATH:
            return {
                ...state,
                prevPath: action.prevPath,
            };
        case types.SUBMIT_REQUEST:
            return {
                ...state,
                fetching: true,
                submitSuccess: false,
                error: null,
                requestData,
            };
        case types.SUBMIT_SUCCESS:
            return {
                ...state,
                submitSuccess: true,
                requestData: null,
            };
        case types.SUBMIT_SUCCESS_REDIRECT:
            return {
                ...state,
                fetching: true,
                submitSuccess: true,
            };
        case types.SUBMIT_FAILURE:
            return {
                ...state,
                submitSuccess: false,
                error,
            };
        case types.LOAD_ADDLIMIT_TRANSACTION:
            return {
                ...state,
                summary,
            };
        case globalTypes.RESET_SELECTED_ELEMENTS:
        case types.SET_FETCHING:
            return {
                ...state,
                fetching,
            };
        case types.SET_LOADING_LIMITS:
            return {
                ...state,
                loadingLimits: action.loadingLimits,
                limitsError: null,
            };
        case types.SET_PRE_LIMITS:
            return {
                ...state,
                loadingLimits: false,
                limitsByReason: action.limitsByReason,
                environmentLimit: action.environmentLimit,
                limitsError: null,
            };
        case types.LIMITS_FAILURE:
            return {
                ...state,
                loadingLimits: false,
                limitsByReason: null,
                environmentLimit: null,
                limitsError: action.error,
            };
        case types.CLEAN_DATA:
            return { ...INITIAL_STATE, prevPath: state.prevPath };
        default:
            return state;
    }
};

export const actions = {
    setRequestData: (requestData) => ({
        type: types.SET_REQUEST_DATA,
        requestData,
    }),
    setPrevPath: (prevPath) => ({
        type: types.SET_PREV_PATH,
        prevPath,
    }),
    submitRequest: (requestData) => ({
        type: types.SUBMIT_REQUEST,
        requestData,
    }),
    cleanData: () => ({
        type: types.CLEAN_DATA,
    }),
    loadAddLimitTransaction: (summary) => ({
        type: types.LOAD_ADDLIMIT_TRANSACTION,
        summary,
    }),
    setFetching: (fetching) => ({
        type: types.SET_FETCHING,
        fetching,
    }),
    loadPreLimits: () => ({
        type: types.LOAD_PRE_LIMITS,
    }),
    setPreLimits: (limitsByReason, environmentLimit) => ({
        type: types.SET_PRE_LIMITS,
        limitsByReason,
        environmentLimit,
    }),
    setLoadingLimits: (loadingLimits) => ({
        type: types.SET_LOADING_LIMITS,
        loadingLimits,
    }),
    limitsFailure: (error) => ({
        type: types.LIMITS_FAILURE,
        error,
    }),
};

export const selectors = {
    getFetching: ({ addLimitRequest }) => addLimitRequest.fetching,
    getRequestData: ({ addLimitRequest }) => addLimitRequest.requestData,
    getSubmitSuccess: ({ addLimitRequest }) => addLimitRequest.submitSuccess,
    getError: ({ addLimitRequest }) => addLimitRequest.error,
    getSummary: ({ addLimitRequest }) => addLimitRequest.summary,
    getPrevPath: ({ addLimitRequest }) => addLimitRequest.prevPath,
    getLoadingLimits: ({ addLimitRequest }) => addLimitRequest.loadingLimits,
    getLimitsByReason: ({ addLimitRequest }) => addLimitRequest.limitsByReason,
    getEnvironmentLimit: ({ addLimitRequest }) => addLimitRequest.environmentLimit,
};
